/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Breakpoint } from 'react-socks';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';

class NewRouteProgress extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            overTheLine: false
        };

        this.goToStep = this.goToStep.bind(this);

    }


    goToStep(e) {
		let step = parseInt(e.currentTarget.dataset.step, 10),
			currentSection = parseInt(e.currentTarget.dataset.current, 10),
            overTheLine = this.state.overTheLine,
            baseUrl = '';

		if (step > currentSection) {
            if (step === 3 &&
                (this.props.newRoute.inputs.length === 0 ||
                 this.props.newRoute.inputs[0].inputValid === undefined ||
                 this.props.newRoute.inputs[0].inputValid === false)) {
                 overTheLine = true;
            }
            if (step === 2 && (this.props.newRoute.inputs.length === 0 || this.props.newRoute.inputs[0].feedValid === undefined)) {
                overTheLine = true;
            }
		}

        if (overTheLine) {
            this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.route.onboarding, 'ROUTE_CREATE'));
            return;
        }

        if (this.props.router.location.pathname.match("content")) {
            baseUrl = '/content/feed';
        } else {
            baseUrl = '/share/automate';
        }

		if (step === 1) {
			this.props.router.navigate(`${baseUrl}/new/inputs`);
		} else if (step === 2) {
            this.props.router.navigate(`${baseUrl}/new/configure`);
		} else if (step === 3) {
            this.props.router.navigate(`${baseUrl}/new/outputs`);
		}

	}

    render() {
        let sourceIcon = null,
            sourceClass = 'progress-icon',
            sourceLabelClass = 'progress-label',
            settingsClass = 'progress-icon',
            settingsLabelClass = 'progress-label',
            socialClass = 'progress-icon',
            socialLabelClass = 'progress-label',
            progressBars = null,
            TypeIcon = null,
            headline = null,
            markItZero = null,
            constants = this.props.app.config.constants;

        if (this.props.inputType === 'wordpress') {
			TypeIcon = IconFactory.wordpress;
		} else {
			TypeIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.inputType)];
		}

		if (this.props.inputType === 0) {
			TypeIcon = IconFactory.search;
		}


        if (this.props.currentSection === 1) {
            progressBars = (
                <div className="progress-bar"></div>
            );
            sourceClass += ' active';
            sourceLabelClass += ' active';
        } else if (this.props.currentSection === 2) {
            progressBars = (
                <div>
                    <div className="progress-bar"></div>
                    <div className='progress-bar half'></div>
                </div>
            );
            sourceClass += ' active';
            sourceLabelClass += ' active';
            settingsClass += ' active';
            settingsLabelClass += ' active';
        } else if (this.props.currentSection === 3) {
            progressBars = (
                <div className="progress-bar full"></div>
            );
            sourceClass += ' active';
            sourceLabelClass += ' active';
            settingsClass += ' active';
            settingsLabelClass += ' active';
            socialClass += ' active';
            socialLabelClass += ' active';
        }

        // if ((parseInt(this.props.user.detail.id, 10) % 2) === 0) {
            headline = (
                <div className="input-type-headline">
                    Let's Start Posting
                </div>
            );
        // } else {
        //     headline = (
        //         <div className="input-type-headline">
        //             Let's Start Auto Posting
        //         </div>
        //     );
        // }

        let socialsLabel = "Select Outputs",
            mobileSocialsLabel = "Outputs";
        if (this.props.socials.list.length === 1) {
            socialsLabel = 'Select Outputs (1)';
            mobileSocialsLabel = "Output (1)";
        } else if (this.props.socials.list.length) {
            socialsLabel += ` (${this.props.socials.list.length})`;
            mobileSocialsLabel += ` (${this.props.socials.list.length})`;
        }

        let typeIcon = (<i className="fa fa-check"></i>);
        if (this.props.currentSection === 1) {
            typeIcon = (<i className="fa fa-circle"></i>);
        }

        let inputLabel = "Select Input",
            mobileLabel = "Input";
        if (this.props.currentSection > 1) {
            let input = this.props.newRoute.inputs[0];
            if (input) {
                switch (input.type) {
                    case constants.INPUT_TYPE_FEED:
                        inputLabel = "Feed Input Selected";
                        mobileLabel = "Feed";
                        break;

                    case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                        inputLabel = "Instagram Input Selected";
                        mobileLabel = "Instagram";
                        break;

                    case constants.INPUT_TYPE_FACEBOOK:
                        inputLabel = "Facebook Input Selected";
                        mobileLabel = "Facebook";
                        break;

                    default:
                        break;
                }
            }
        }

        return (
            <div className="new-route-progression">
                {headline}
                <div className="progress-steps">
                    <div className="progress-bars">
                        {progressBars}
                    </div>
                    <div className="progress-step create" onClick={this.goToStep} data-step="1" data-current={this.props.currentSection} role="button" aria-label="choose source">
                        <div className={sourceClass}>
                            {(this.props.currentSection === 1) ? (<i className="fa fa-circle"></i>) : null}
                            {(this.props.currentSection > 1) ? (<i className="fa fa-check"></i>) : null}
                        </div>
                        <div className={sourceLabelClass}>
                            <Breakpoint desktop only>
                                {inputLabel}
                            </Breakpoint>
                            <Breakpoint mobile only>
                                {mobileLabel}
                            </Breakpoint>
                        </div>
                    </div>
                    <div className="progress-step config" onClick={this.goToStep} data-step="2" data-current={this.props.currentSection} role="button" aria-label="configure source">
                        <div className={settingsClass}>
                            {(this.props.currentSection === 2) ? (<i className="fa fa-circle"></i>) : null}
                            {(this.props.currentSection > 2) ? (<i className="fa fa-check"></i>) : null}
                        </div>
                        <div className={settingsLabelClass}>
                            <Breakpoint desktop only>
                                Post Settings
                            </Breakpoint>
                            <Breakpoint mobile only>
                                Settings
                            </Breakpoint>
                        </div>
                    </div>
                    <div className="progress-step social" onClick={this.goToStep} data-step="3" data-current={this.props.currentSection} role="button" aria-label="add socials">
                        <div className={socialClass}>
                            {(this.props.currentSection === 3) ? (<i className="fa fa-circle"></i>) : null}
                        </div>
                        <div className={socialLabelClass}>
                            <Breakpoint desktop only>
                                {socialsLabel}
                            </Breakpoint>
                            <Breakpoint mobile only>
                                {mobileSocialsLabel}
                            </Breakpoint>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NewRouteProgress.displayName = "NewRouteProgress";

export default NewRouteProgress;
